<template>
  <div class="main">
    <caiwushenheTop @now="reNow"></caiwushenheTop>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button></template></selectTool>

    <Table show-summary border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">

      <template slot-scope="{ row, index }" slot="bohui">
        <Button @click="openBohui(row)" size="small" type="primary" v-if="row.checkStatus != 3"
          :disabled="row.payAudit == 1 || row.receiveAudit == 1">驳回</Button>
        <span v-else>已驳回</span>
      </template>

      <template v-if="row.checkStatus != 3" slot-scope="{ row, index }" slot="yingfu">
        <Button size="small" @click="chexiao(row, index)" v-if="row.payAudit == 1" type="error">撤销</Button>
        <Button size="small" @click="openUpdateStatus(row, index)" v-if="row.payAudit != 1" type="primary">审核</Button>
      </template>

      <template v-if="row.checkStatus != 3" slot-scope="{ row, index }" slot="yingshou">
        <Button size="small" @click="chexiao1(row, index)" v-if="row.receiveAudit == 1" type="error">撤销</Button>
        <Button size="small" @click="openUpdateStatus1(row, index)" v-if="row.receiveAudit != 1"
          type="primary">审核</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>

    <form-model :overAuto="true" title="应付账款审核" fullscreen ref="renwuzhuangtai">
      
      <div  ref="scroll"slot="topcontent">

        <h2 style="margin-bottom: 10px;">订单详情
          <Button @click="heipUpdate" size="small">帮忙修改</Button>
        </h2>
        <div style="height: 500px;overflow-y: auto;overflow-x: hidden;" ref="onoContent"></div>
        <h2 style="margin-bottom: 10px;margin-top: 20px;">客户报价单
          <Tag color="red">财务审核用，请不要在此修改报价单</Tag>
        </h2>
        <baojia v-if="openBaojia" style="height:500px;" slot="endcontent" ref="baojia">
        </baojia>
        <p v-else>暂无报价单</p>
      </div>
      <h2 style="margin-top: 30px;margin-bottom: 10px;" slot="topcontent">审核项目
        <Tag color="red">该区域属于审核区域，费用项目不符的在此修改
        </Tag>
      </h2>
      <tableForm @addItem="updateStatusItem.ordersChargesList[$event + 1].isAuto = false;
      updateStatusItem.ordersChargesList[$event + 1].id = 0;
      updateStatusItem.ordersChargesList[$event + 1].type = 0;" @fromInputNumber="feiyongbianhua"
        @fromSelect="feiyongbianhua" slot="ordersChargesList" ref="ordersChargesList" :forms="yingfuForms"
        :item1="ordersChargesListItem" v-model="updateStatusItem.ordersChargesList">
      </tableForm>
      <navShenhe slot="btnLeft" @scroll="$refs.renwuzhuangtai.scroll($event)"></navShenhe>
      <Button slot="btn" type="primary" @click="updateStatus">通过审核</Button>
    </form-model>
    <form-model :overAuto="true" title="应收账款审核" fullscreen ref="renwuzhuangtai1">
      <div slot="topcontent">
        <h2 style="margin-bottom: 10px;">订单详情
          <Button @click="heipUpdate" size="small">帮忙修改</Button>
        </h2>
        <div style="height: 500px;overflow-y: auto;overflow-x: hidden;" ref="onoContent1">

        </div>
        <h2 style="margin-bottom: 10px;margin-top: 20px;">客户报价单
          <Tag color="red">财务审核用，请不要在此修改报价单</Tag>
        </h2>
        <baojia v-if="openBaojia" style="height:500px;" slot="endcontent" ref="baojia1">
        </baojia>
        <p v-else>暂无报价单</p>
      </div>
      <h2 style="margin-top: 30px;margin-bottom: 10px;" slot="topcontent">审核项目
        <Tag color="red">该区域属于审核区域，费用项目不符的在此修改
        </Tag>
      </h2>
      <tableForm @addItem="updateReceiveAuditStatusItem.ordersChargesList[$event + 1].isAuto = false;
      updateReceiveAuditStatusItem.ordersChargesList[$event + 1].id = 0;
      updateReceiveAuditStatusItem.ordersChargesList[$event + 1].type = 0;
      " @fromInputNumber="feiyongbianhua" @fromSelect="feiyongbianhua" slot="ordersChargesList" ref="ordersChargesList"
        :forms="ordersChargesListForms" :item1="ordersChargesListItem"
        v-model="updateReceiveAuditStatusItem.ordersChargesList">
      </tableForm>
      <navShenhe slot="btnLeft" @scroll="$refs.renwuzhuangtai1.scroll($event)"></navShenhe>
      <Button slot="btn" type="primary" @click="updateStatus1">通过审核</Button>
    </form-model>
    <form-model title="驳回" width="400" ref="bohui">


      <Button slot="btn" type="primary" @click="bohui">驳回</Button>
    </form-model>
    <orderDetail @finishUpdata="finishUpdata" v-show="false" ref="detail"></orderDetail>

  </div>
</template>

<script>
var kehuitems = [];
var now = true;
var b = { now: true };
import orderDetail from "../fahuo/xitongkaidan.vue";
import caiwushenheTop from "./caiwushenheTop.vue";
import baojia from "../kehu/baojia.vue"
import navShenhe from "./navShenhe"
export default {
  components: { caiwushenheTop, orderDetail, baojia, navShenhe },
  data() {
    return {
      isAdd: false,
      openForm: false,
      openBaojia: false,
      columns: [
        {
          type: "expand",
          width: 70,
          align: "center",
          render: (h, data) => {
            return h("Table", {
              //局部注册组件不需要加引号
              props: {
                data: data.row.ordersChargesList,
                columns: this.ordersChargesListForms,
              },
            });
          },
        },
        {
          title: "订单号",
          key: "no",
        },
        {
          title: "应收审核",
          key: "receiveAudit2",
        },
        {
          title: "应付审核",
          key: "payAudit2",
        },
        {
          title: "应收人民币",
          key: "receiveAmountTotal",
        },
        {
          title: "应付人民币",
          key: "payAmountTotal",
        },
        {
          title: "客户",
          key: "customer",
        },
        {
          title: "客户单号",
          key: "customerNo",
        },
        {
          title: "始发地",
          key: "addressS",
        },
        {
          title: "目的地",
          key: "addressD",
        },
        {
          title: "业务类型",
          key: "bpMode2",
        },
        {
          title: "送货时间",
          key: "sendTime2",
        },
        {
          title: "装货时间",
          key: "shipmentTime2",
        },
        {
          title: "业务员",
          key: "saleman",
        },
        {
          title: "驳回",
          slot: "bohui",
          width: 70,
          align: "center",
          fixed: "right",
        },
        {
          title: "应付审核",
          slot: "yingfu",
          width: 70,
          align: "center",
          fixed: "right",
        },
        {
          title: "应收审核",
          slot: "yingshou",
          width: 70,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        cid: "",
        customer: "",
        ono: "",
        no: "",
        contact: "",
        tel: "",
        carType: "",
        tradeType: "",
        bpMode: 0,
        money: 0,
        currency: "",
        saleman: "",
        salemanAccount: "",
        imgPath: "",
        processTime: "",
        remark: "",
      },

      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
        ono: "",
        customerNo: "",
        bpMode: "",
        auditStatus: "",
        keyWork: "",
        checkStatuses: [],
        checkStatus: -1
        //审查状态(-1 -全部 ，1--未送审 2--已送审 3--被驳回 4 应付已审，5 应收已审
      },
      total: 0,
      forms: [],
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "客户名称",
          key: "cid",
          type: "Select",
          selectType: "obj",
          selectItems: kehuitems,
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "业务类型",
          key: "bpMode",
          required: "true",
          val: 0,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
        },
        {
          title: "审核状态",
          key: "auditStatus",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["auditStatus"],
        },
      ],
      bohuiItem: {
        no: '',
        comment: '',
        remark: ''
      },
      bohuiForms: [
        {
          title: "驳回理由",
          key: "comment",
          type: 'Select',
          selectItems: ['货物信息填写错误', '价格计算错误', '其他原因',],
          span: 24,
          required: true
        },
        {
          title: "备注信息",
          key: "remark",
          type: 'Input',
          type1: 'textarea',
          span: 24,
        },
      ],
      updateStatusItem: {
        payAuditStatus: 1,
        ordersChargesList: [],
        ono: "",
      },
      updateStatusForms: [
        /* {
          title: "审核状态",
          key: "payAuditStatus",
          required: true,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["payReceiveStatus"], //
          span: 24,
        }, */
        {
          title: "费用项目",
          key: "ordersChargesList",
          slotForm: "ordersChargesList",
          span: 24,
          hideLabel: true,
        },
      ],
      updateReceiveAuditStatusItem: {
        receiveAuditStatus: 1,
        ordersChargesList: [],
        ono: "",
      },
      updateReceiveAuditStatusForms: [
        /* {
          title: "审核状态",
          key: "receiveAuditStatus",
          required: true,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["payReceiveStatus"], //
          span: 24,
        }, */
        {
          title: "费用项目",
          key: "ordersChargesList",
          slotForm: "ordersChargesList",
          span: 24,
          hideLabel: true,
        },
      ],
      ordersChargesListForms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          width: 200
        },
        {
          title: "自动计算",
          key: "isAuto",
          type: "bool",
          required: true,
          width: 100
        },
        {
          title: "币别",
          key: "currencyForeign",
          required: true,
          span: 4,
          type: "Select",
          selectItems: this.lydic.getA("mType"),
          width: 130
        },
        {
          title: "应收（外币）",
          key: "receiveAmountForeign",
          type: "InputNumber",
          required: true,
          readonly: false,
          width: 130
        },
        {
          title: "应收（人民币）",
          key: "receiveAmount",
          type: "InputNumber",
          required: true,
          readonly: false,
          width: 130
        },
        {
          title: "应付（人民币）",
          key: "payAmount",
          type: "InputNumber",
          readonly: false,
        },
        {
          title: "应付（外币）",
          key: "payAmountForeign",
          type: "InputNumber",
          readonly: false,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          width: 300
        },
      ],
      yingfuForms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          width: 200
        },
        {
          title: "自动计算",
          key: "isAuto",
          type: "bool",
          required: true,
          width: 100
        },
        {
          title: "应付（外币）",
          key: "payAmountForeign",
          type: "InputNumber",
          required: true,
          width: 130
        },
        {
          title: "币别",
          key: "currencyForeign",
          required: true,
          span: 4,
          type: "Select",
          selectItems: this.lydic.getA("mType"),
          width: 130,
        },
        {
          title: "应付（人民币）",
          key: "payAmount",
          type: "InputNumber",
          required: true,
          width: 130
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          width: 300
        },
      ],
      ordersChargesListItem: {},
      ttext: ''

    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    scrollTop(v) {
      console.log(v);
      this.$refs.renwuzhuangtai.scroll(v)
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/finance/listAudit",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].receiveAudit2 = this.lydic.getVal(
            "payReceiveStatus",
            data[i].receiveAudit
          );
          data[i].payAudit2 = this.lydic.getVal(
            "payReceiveStatus",
            data[i].payAudit
          );
          data[i].sendDate2 = this.utils.time(data[i].sendDate, "yymmdd");
          // data[i].isTax2 = this.$t("bool." + data[i].isTax);
          // data[i].isTransfers2 = this.$t("bool." + data[i].isTransfers);
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
          data[i].shipmentTime2 = this.utils.time(
            data[i].shipmentTime,
            "yymmddhhmm"
          );
          data[i].sendTime2 = this.utils.time(data[i].sendTime, "yymmddhhmm");
          data[i].status2 = this.lydic.getVal("orderStatus", data[i].status);
        }
        this.tableData = data;
        console.log(data);
      });
    },
    getDetail(row) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/infoNo",
        data: { no: row.no },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.updateData = data;
        setTimeout(() => {
          this.$refs.detail.openDetail(data);
          var t = this.$refs.detail.$refs.detail.$refs.item.$el;
          this.$refs.detail.$refs.detail.$el.style.display = 'none';
          if (this.itemNow == 'updateStatusItem') {
            //应付
            this.$refs.onoContent.appendChild(t);
          } else {
            //应收
            this.$refs.onoContent1.appendChild(t);
          }

          //console.log(document.getElementById('aaff'))
          console.log(t);
        }, 200);
      });
    },
    getBaojiaDetail(row) {
      this.openBaojia = false;
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/customerQuotation/info",
        data: {
          id: row.quotationId
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log(res);
        var data = res.data.data;
        if (data == null) {

        } else {
          this.openBaojia = true;
          setTimeout(() => {

            if (this.itemNow == 'updateStatusItem') {
              //应付
              this.$refs.baojia.reach(data.priceTemplet);
              this.$refs.baojia.hideLeft = true;
              this.$refs.baojia.width = 0;
            } else {
              //应收
              this.$refs.baojia1.reach(data.priceTemplet);
              this.$refs.baojia1.hideLeft = true;
              this.$refs.baojia1.width = 0;
            }
          }, 200);
        }

      });
    },
    //帮忙修改
    heipUpdate() {
      this.$refs.detail.opemUpdate(this.updateData);
    },
    getPayDetail(ono, type) {
      //收付审核类型(0-应收审核，1-应付审核)		true	

      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/finance/ordersChargesList",
        data: { ono, type },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;

        if (type === 1) {
          this.updateStatusItem.ordersChargesList = data;
          this.updateStatusItem.ono = ono;
          this.$refs.renwuzhuangtai.reach(
            this.updateStatusForms,
            this.updateStatusItem
          );
        } else {
          this.updateReceiveAuditStatusItem.ordersChargesList = data;
          this.updateReceiveAuditStatusItem.ono = ono;
          this.$refs.renwuzhuangtai1.reach(
            this.updateReceiveAuditStatusForms,
            this.updateReceiveAuditStatusItem);
          console.log('司收费用', data);
        }




      });
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort + "/cloud-tms-server-fms/accountsPayable/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    openUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openBohui(row) {
      console.log(row);
      this.bohuiItem.no = row.no;
      this.$refs.bohui.reach(this.bohuiForms, this.bohuiItem);
    },
    bohui(name) {
      var a = this.$refs.bohui.getItem();
      if (!a) {
        return;
      }
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/omcRefusalComment/add",
        data: this.bohuiItem,
      }).then((res) => {
        this.$Spin.hide();
        if (res) {
          this.$refs.bohui.close();
          this.getList();
        }
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    finishUpdata() {
      this.$refs.renwuzhuangtai.close();
      this.$refs.renwuzhuangtai1.close();
      this.getList();
      if (this.itemNow == 'updateStatusItem') {
        this.openUpdateStatus(this.nowOno);
      } else {
        this.openUpdateStatus1(this.nowOno);
      }
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    //费用变化自动汇率结算
    feiyongbianhua(v, k, index, list) {

      //this.updateReceiveAuditStatusItem.ordersChargesList
      // return;
      //用到的字段：
      //undefi
      //v--值 b--主键
      if (k == "receiveAmountForeign") {
        this.huiLvJiaGe(v, k, index, "receiveAmount");
      }
      if (k == "payAmountForeign") {
        this.huiLvJiaGe(v, k, index, "payAmount");
      }
      console.log(t);
      if (k == "currencyForeign") {

        if (this.itemNow == 'updateStatusItem') {
          var m = this[this.itemNow].ordersChargesList[index].payAmountForeign;
          this.huiLvJiaGe(m, k, index, "payAmount");
        } else if (this.itemNow = "updateReceiveAuditStatusItem") {
          var t = this[this.itemNow].ordersChargesList[index].receiveAmountForeign;

          this.huiLvJiaGe(t, k, index, "receiveAmount");
        }


      }
    },
    //通过汇率计算，收费项目用到
    huiLvJiaGe(v, k, index, key) {
      console.log(11111, v);
      var currency = this[this.itemNow].ordersChargesList[index].currencyForeign;
      if (currency == "人民币") {
        this[this.itemNow].ordersChargesList[index][key] = v;
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/rate/getRate",
          data: { currency: currency, cid: this.item.cid },
        }).then((res) => {
          var huilv = res.data.data.rate;
          this[this.itemNow].ordersChargesList[index][key] = Number(
            (v * huilv).toFixed(2)
          );
        });
      }
    },
    //点击应付按钮
    openUpdateStatus(row) {
      this.itemNow = 'updateStatusItem';
      this.getPayDetail(row.no, 1);
      this.nowOno = row;
      this.getDetail(row);
      this.getBaojiaDetail(row);
      /* this.updateStatusItem.ordersChargesList = row.ordersChargesList;
      this.updateStatusItem.ono = row.no;
      this.$refs.renwuzhuangtai.reach(
        this.updateStatusForms,
        this.updateStatusItem
      ); */
    },
    chexiao(v) {
      this.$Modal.confirm({
        title: "是否撤销审核",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort +
              "/cloud-tms-server-fms/finance/updatePayCancelStatus",
            data: { ono: v.no, payCancelStatus: 1 },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    chexiao1(v) {
      this.$Modal.confirm({
        title: "是否撤销审核",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort +
              "/cloud-tms-server-fms/finance/updateReceiveCancelStatus",
            data: { ono: v.no, receiveCancelStatus: 1 },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    updateStatus() {
      var a = this.$refs.renwuzhuangtai.getItem();
      if (!a) {
        return;
      }
      console.log(this.updateStatusItem);
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/finance/updatePayAuditStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.renwuzhuangtai.close();
          this.getList();
        }
      });
    },
    //点击应收按钮
    openUpdateStatus1(row) {
      //this.updateReceiveAuditStatusItem.receiveAuditStatus = row.receiveAudit;
      this.itemNow = 'updateReceiveAuditStatusItem';
      this.getPayDetail(row.no, 0);
      this.nowOno = row;
      this.getDetail(row);
      this.getBaojiaDetail(row);
      return;
      this.updateReceiveAuditStatusItem.ordersChargesList =
        row.ordersChargesList;
      console.log(row.ordersChargesList)
      this.updateReceiveAuditStatusItem.ono = row.no;
      this.$refs.renwuzhuangtai1.reach(
        this.updateReceiveAuditStatusForms,
        this.updateReceiveAuditStatusItem
      );
    },
    updateStatus1() {
      var a = this.$refs.renwuzhuangtai1.getItem();
      if (!a) {
        return;
      }
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/finance/updateReceiveAuditStatus",
        data: this.updateReceiveAuditStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.renwuzhuangtai1.close();
          this.getList();
        }
      });
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    },
    //获取状态查询
    reNow(v) {
      this.searchItem.checkStatus = v;

      if (v == -1) {
        this.searchItem.checkStatuses = [];
      } else if (v == 2) {
        this.searchItem.checkStatuses = [2, 4, 5];
      } else {
        this.searchItem.checkStatuses = [v];
      }
      this.getList();
    }
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuList();
    //
  },
};
</script>

<style>
.shenheContent {
  overflow: auto;
  height: calc(100% - 100px);
  background: red;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/caiwushenhe.vue